<template>
    <div>
        <Breadcrumbs main="" title="官方通知" />
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="faq-wrap">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row default-according style-1 faq-accordion" id="accordionoc">
                            <div class="col-12">
                                <b-card no-body v-for="(item, i) in pagedNews" :key="item.newsId">
                                    <b-card-header header-tag="header" role="tab">
                                        <h5 class="mb-0">
                                            <b-button v-if="item.link" :href="item.link" target="_blank"
                                                rel="noopener noreferrer" class="btn btn-link collapsed row p-0">
                                                <div class="col-lg-10 col-12 text-left">
                                                    <span>{{ item.title }}</span>
                                                </div>
                                                <div class="col-lg-2 col-12 launchTime">
                                                    <div class="mr-4">
                                                        <span>发布日期:</span><custom-date :date="item.createdDate"
                                                            :args="'yyyy-M-d'"></custom-date>
                                                    </div>
                                                </div>
                                            </b-button>
                                            <b-button v-else v-b-toggle="'collapseicon' + item.newsId"
                                                :id="'news_' + item.newsId" :ref="'news_' + item.newsId"
                                                class="btn btn-link collapsed row p-0">
                                                <div class="col-lg-10 col-12 text-left">
                                                    <span>{{ item.title }}</span>
                                                </div>
                                                <div class="col-lg-2 col-12 launchTime">
                                                    <span>发布日期:</span><custom-date :date="item.createdDate"
                                                        :args="'yyyy-M-d'"></custom-date>
                                                </div>
                                            </b-button>
                                        </h5>
                                    </b-card-header>
                                    <b-collapse :id="'collapseicon' + item.newsId" accordion="accordion-1" role="tabpanel">
                                        <b-card-body>
                                            {{ item.content }}
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 分页器 -->
                <div class="text-center">
                    <!-- <Pager :skip="skip" :pageSize="pageSize" :total="totalRecords" @pageChange="onPageChange" /> :page-sizes="pageSizes"-->
                    <pager :skip="skip" :take="take" :total="total" :button-count="buttonCount" :info="info" :type="type"
                        :previous-next="previousNext" @pagechange="handlePageChange" @pagesizechange="handlePageSizeChange">
                    </pager>
                </div>
            </div>
        </div>
        <!-- Container-fluid Ends-->
    </div>
</template>
<script>
import { Pager } from '@progress/kendo-vue-data-tools';

import { ExhibitionNewsService } from "@/_services/exhibitionnews";
export default {
    // name: 'pager',
    data() {
        return {
            newsid: this.$route.query.newsid,
            reload: false,
            news: [],
            skip: 0,
            take: 5,
            buttonCount: 5,
            type: "numeric",
            info: true,
            //pageSize: 5,
            //pageSizes: [5, 10, 20, 50, 100],
            previousNext: true,
            total: this.$route.query.totalRecords,
            //title: "Event log",
            events: []
        };
    },
    components: {
        "pager": Pager
    },
    watch: {
        news(newVal) {
            console.log("news newVal:" + newVal);
            this.reload = false;
            if (newVal != null) {
                this.$nextTick(() => {
                    this.reload = true;
                })
            }
        }
    },
    //计算层
    computed: {
        //重新过滤图片数据
        filesfilter() {
            return function (requesid) {
                return this.files.filter(function (item, index) {
                    if (item.requestId == requesid) {
                        return item;
                    }
                });
            }
        },
        pagedNews() {
            return this.news.slice(this.skip, this.skip + this.take);
        }
    },
    created() {
        this.getExhibitionNewsAsync();
    },
    methods: {
        async getExhibitionNewsAsync() {
            var that = this;
            ExhibitionNewsService.GetExhibitionNewsAsync(this.skip, this.take).then(response => {
                console.log(response);
                if (response.statusCode == 200) {
                    var data = response.data;
                    that.news = data;//data.slice(that.skip, that.skip + that.pageSize);
                    //that.totalRecords = data.length; // 更新总记录数
                    that.total = data.length;
                    if (that.newsid != undefined) {
                        //延时触发，展开
                        setTimeout(() => {
                            document.getElementById("news_" + this.newsid).click();
                        }, 50);
                    }
                }
            });
        },
        handlePageChange: function (event) {
            this.skip = event.skip;
            this.take = event.take;
            this.getExhibitionNewsAsync();
        },
        handlePageSizeChange: function (event) {
            this.skip = event.skip;
            this.take = event.take;
        }
    },
    filters: {
        formatDate: function (value, args) {
            var dt = new Date(value);
            if (args == 'yyyy-M-d') {// yyyy-M-d
                let year = dt.getFullYear();
                let month = dt.getMonth() + 1;
                let date = dt.getDate();
                return `${year}-${month}-${date}`;
            } else if (args == 'yyyy-M-d H:m:s') {// yyyy-M-d H:m:s
                let year = dt.getFullYear();
                let month = dt.getMonth() + 1;
                let date = dt.getDate();
                let hour = dt.getHours();
                let minute = dt.getMinutes();
                let second = dt.getSeconds();
                return `${year}-${month}-${date} ${hour}:${minute}:${second}`;
            } else if (args == 'yyyy-MM-dd') {// yyyy-MM-dd
                let year = dt.getFullYear();
                let month = (dt.getMonth() + 1).toString().padStart(2, '0');
                let date = dt.getDate().toString().padStart(2, '0');
                return `${year}-${month}-${date}`;
            } else if (args == 'HH:mm:ss') {// HH:mm:ss
                let hour = dt.getHours().toString().padStart(2, '0');
                let minute = dt.getMinutes().toString().padStart(2, '0');
                let second = dt.getSeconds().toString().padStart(2, '0');
                return `${hour}:${minute}:${second}`;
            } else {// yyyy-MM-dd HH:mm:ss
                let year = dt.getFullYear();
                let month = (dt.getMonth() + 1).toString().padStart(2, '0');
                let date = dt.getDate().toString().padStart(2, '0');
                let hour = dt.getHours().toString().padStart(2, '0');
                let minute = dt.getMinutes().toString().padStart(2, '0');
                let second = dt.getSeconds().toString().padStart(2, '0');
                return `${year}-${month}-${date} ${hour}:${minute}:${second}`;
            }
        }
    },
}
</script>
<style>
.noticeTitle {
    color: #E64800 !important;
}
</style>
  